import { render, staticRenderFns } from "./MotivoBajaComponent.vue?vue&type=template&id=7327e7a8&"
import script from "./MotivoBajaComponent.vue?vue&type=script&lang=js&"
export * from "./MotivoBajaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports